import React from 'react';
import Fade from "react-reveal/Fade";
const Timeline = () => (
    <section className="section-c skills-timeline-section">
        <svg className="holes" viewBox="0 0 1189 22" preserveAspectRatio="xMinYMin meet">
            <circle cx="37.15" cy="11" r="11"></circle>
            <circle cx="74.31" cy="11" r="11"></circle>
            <circle cx="111.46" cy="11" r="11"></circle>
            <circle cx="148.61" cy="11" r="11"></circle>
            <circle cx="185.77" cy="11" r="11"></circle>
            <circle cx="222.92" cy="11" r="11"></circle>
            <circle cx="260.07" cy="11" r="11"></circle>
            <circle cx="297.23" cy="11" r="11"></circle>
            <circle cx="334.38" cy="11" r="11"></circle>
            <circle cx="371.54" cy="11" r="11"></circle>
            <circle cx="408.69" cy="11" r="11"></circle>
            <circle cx="445.84" cy="11" r="11"></circle>
            <circle cx="483" cy="11" r="11"></circle>
            <circle cx="520.15" cy="11" r="11"></circle>
            <circle cx="557.3" cy="11" r="11"></circle>
            <circle cx="594.46" cy="11" r="11"></circle>
            <circle cx="631.61" cy="11" r="11"></circle>
            <circle cx="668.76" cy="11" r="11"></circle>
            <circle cx="705.92" cy="11" r="11"></circle>
            <circle cx="743.07" cy="11" r="11"></circle>
            <circle cx="780.22" cy="11" r="11"></circle>
            <circle cx="817.38" cy="11" r="11"></circle>
            <circle cx="854.53" cy="11" r="11"></circle>
            <circle cx="891.69" cy="11" r="11"></circle>
            <circle cx="928.84" cy="11" r="11"></circle>
            <circle cx="965.99" cy="11" r="11"></circle>
            <circle cx="1003.15" cy="11" r="11"></circle>
            <circle cx="1040.3" cy="11" r="11"></circle>
            <circle cx="1077.45" cy="11" r="11"></circle>
            <circle cx="1114.61" cy="11" r="11"></circle>
            <circle cx="1151.76" cy="11" r="11"></circle>
            <path d="M1253,389a11,11,0,0,0,0,22V389Z" transform="translate(-64 -389)"></path>
            <path d="M64,389v22A11,11,0,0,0,64,389Z" transform="translate(-64 -389)"></path>
        </svg>
        <div className="section-title">
            <h2>Education & Work </h2>
        </div>
        <div className="timeline-wrapper">
            <ul className="timeline">
                <Fade left>
                    <li>
                        <div className="icon">
                            <i className="fa fa-graduation-cap fa-2x" aria-hidden="true"></i>
                        </div>
                        <div className="description">
                            <h3 className="animated">​Tudor Vianu National High-School of Computer Science</h3>
                            <h4 className="animated">Bucharest, Romania</h4>
                            <div className="date animated">September 2009 - June 2013</div>
                            <p>
                                Romanian Baccalaureate: 93% overall (Mathematics, Computer Science)
                        </p>
                        </div>
                    </li>
                </Fade>
                <Fade right>
                    <li>
                        <div className="icon">
                            <i className="fa fa-graduation-cap fa-2x" aria-hidden="true"></i>
                        </div>
                        <div className="description">
                            <h3 className="animated">​Master of Engineering in Computer Science, University of Southampton</h3>
                            <h4 className="animated">Southampton, United Kingdom​​</h4>
                            <div className="date animated">September 2013 - June 2017</div>
                            <p>
                                Graduated with First Class Honours
                            </p>
                        </div>
                    </li>
                </Fade>
                <Fade left>
                    <li>
                        <div className="icon">
                            <i className="fa fa-suitcase fa-2x" aria-hidden="true"></i>
                        </div>
                        <div className="description">
                            <h3 className="animated">Mobile Application Developer (Intern)</h3>
                            <h4 className="animated">IBM Romania - Bucharest, Romania</h4>
                            <div className="date animated">June 2015 - August 2015</div>
                            <p>
                                Part of the development team working on a mobile application made with Ionic (Cordova, AngularJS, HTML5, CSS3)
                            </p>
                        </div>
                    </li>
                </Fade>
                <Fade right>
                    <li>
                        <div className="icon">
                            <i className="fa fa-suitcase fa-2x" aria-hidden="true"></i>
                        </div>
                        <div className="description">
                            <h3 className="animated">Frontend Developer (Part of Master's Disseration)</h3>
                            <h4 className="animated">Snowflake Software - Southampton, United Kingdom</h4>
                            <div className="date animated">October 2016 - January 2017</div>
                        </div>
                        <p>
                            Responsible for the development of a web application (AngularJS) that highlights the business value of Laminar Data – a cloud-based RESTful API created by Snowflake, dedicated to managing flight, weather and aeronautical data.
                        </p>
                    </li>
                </Fade>
            </ul>
        </div>
    </section>
);

export default Timeline;


// WEBPACK FOOTER //
// ./src/components/skills/Timeline/index.js